// extracted by css-extract-rspack-plugin
export default {"img":"img-GCrExQ","pin":"pin-X9eEWu"};